<template>
  <div class="pb-3" >
    <va-card :title="$t(`columnists.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(upload)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="max:200|required" name="Bio" v-slot="{ errors }">
                <va-input
                  v-model="columnist.bio"
                  :label="$t('columnists.forms.bioLabel')"
                  :placeholder="$t('columnists.forms.bioPlaceholder')"
                  :success="errors.length == 0 && columnist.bio.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="form-group mt-3 mb-3">
                <va-select
                  :label="$t('columnists.forms.userLabel')"
                  v-model="user"
                  textBy="name"
                  keyBy='id'
                  no-clear
                  :placeholder="$t('columnists.forms.userPlaceholder')"
                  :noOptionsText="$t('columnists.forms.userNoOption')"
                  maxHeight='200px'
                  :options="users.length > 0 ? users : []"
                />
              </div>
              <div v-if='oldImage.length > 0' class="form-group mt-3">
                <img
                  :src="$store.getters['environment/cdn'] + '/profile-image/' + oldImage"
                  style="height: 30vh; max-width: 100%;"
                >
              </div>
              <ValidationProvider name="Imagem" :rules="oldImage.length > 0 ? '' : 'required'" v-slot="{ errors }">
                <div class="form-group mt-3">
                  <label
                    class="va-input__container__label position"
                    style="color: rgb(108, 127, 238);">
                    {{$t('columnists.forms.imageLabel')}}
                  </label>
                  <va-file-upload
                    type="single"
                    v-model="image"
                  />
                  <ErrorMessages :errors='errors'/>
                </div>
              </ValidationProvider>
              <div class="form-group mt-3 mb-3">
                <label
                  class="va-input__container__label position"
                  style="color: rgb(108, 127, 238);">
                  {{ $t('columnists.forms.activeLabel') }}
                </label>
                <div>
                  <va-toggle
                    v-model="columnist.active"
                    small
                    :label="columnist.active ? 'Sim' : 'Não'"
                  />
                </div>
              </div>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import ErrorMessages from '../utils/ErrorMessages'

import gql from 'graphql-tag'
export default {
  name: 'ColumnistAddUpdate',
  components: { ErrorMessages },
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      columnist: {
        bio: '',
        image: '',
        slug: '',
        userId: '',
        active: true,
      },
      oldImage: '',
      image: [],
      user: '',
      users: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  created () {
    this.columnist.bio = ''
    this.columnist.image = ''
    this.columnist.slug = ''
    this.columnist.userId = ''
    this.columnist.active = true
    if (this.updateData !== null) {
      this.columnist_get(this.updateData)
    }
  },
  watch: {
    image (value) {
      if (value.length > 0) {
        this.columnist.image = value[0].name
      }
    },
    updateData (value) {
      if (this.updateData !== null) {
        this.columnist_get(this.updateData)
      } else {
        this.columnist.bio = ''
        this.columnist.image = ''
        this.columnist.slug = ''
        this.columnist.userId = ''
        this.columnist.active = true
      }
    },
    user (value) {
      if (value !== '') {
        this.columnist.userId = value.id
      }
    },
  },
  apollo: {
    users: {
      query: gql`
      query myquery {
        users: user(order_by: {id: asc}) {
          id
          name
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.users.length > 0 && this.users === '') {
            this.users = Object.assign({}, data.users[0])
          }
        }
      },
    },
  },
  methods: {
    slugfy (str) {
      return str.toLowerCase()
        .replace(/[àÀáÁâÂãäÄÅåª]+/g, 'a') // Special Characters #1
        .replace(/[èÈéÉêÊëË]+/g, 'e') // Special Characters #2
        .replace(/[ìÌíÍîÎïÏ]+/g, 'i') // Special Characters #3
        .replace(/[òÒóÓôÔõÕöÖº]+/g, 'o') // Special Characters #4
        .replace(/[ùÙúÚûÛüÜ]+/g, 'u') // Special Characters #5
        .replace(/[ýÝÿŸ]+/g, 'y') // Special Characters #6
        .replace(/[ñÑ]+/g, 'n') // Special Characters #7
        .replace(/[çÇ]+/g, 'c') // Special Characters #8
        .replace(/[ß]+/g, 'ss') // Special Characters #9
        .replace(/[Ææ]+/g, 'ae') // Special Characters #10
        .replace(/[Øøœ]+/g, 'oe') // Special Characters #11
        .replace(/[%]+/g, 'pct') // Special Characters #12
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w-]+/g, '') // Remove all non-word chars
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
    },
    cancel () {
      this.$emit('showAdd', false)
    },
    columnist_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          if (value === 'image') {
            this.oldImage = data[value]
            this.columnist[value] = ''
          } else if (value === 'user') {
            this.user = data[value]
          } else if (value === 'active') {
            this.columnist.active = data[value] !== false
          } else {
            this.columnist[value] = data[value]
          }
        }
      })
    },
    upload () {
      if (this.columnist.image.length !== 0) {
        const formData = new FormData()
        formData.append('file', this.image[0])
        formData.append('path', 'profile-image')
        if (this.updateData !== null) {
          formData.append('deleteFile', this.oldImage)
        }
        this.$axios.post(
          '/api/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        ).then(resp => {
          this.columnist.image = resp.data.filename
          this.onSubmit()
        })
      } else {
        this.columnist.image = this.oldImage
        this.onSubmit()
      }
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { bio, image, userId, active } = this.columnist
      const slug = this.slugfy(this.user.name)
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation MyMutation($userId: Int, $slug: String, $image: String, $bio: String, $active: Boolean, $id: Int!) {
                  update_collumn_by_pk(pk_columns: {id: $id}, _set: {bio: $bio, image: $image, slug: $slug, user_id: $userId, active: $active}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($userId: Int, $slug: String, $image: String, $bio: String, $active: Boolean) {
                  insert_collumn(objects: {bio: $bio, image: $image, slug: $slug, user_id: $userId, active: $active}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            bio,
            image,
            userId,
            slug,
            active,
            id: this.columnist.id,
          } : {
            bio,
            image,
            userId,
            slug,
            active,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          this.columnist.bio = ''
          this.columnist.image = ''
          this.columnist.slug = ''
          this.columnist.userId = ''
          this.columnist.active = true
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          this.columnist.bio = ''
          this.columnist.image = ''
          this.columnist.slug = ''
          this.columnist.userId = ''
          this.columnist.active = true
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
